// Lib
import React from 'react';

import {
  Heading,
  Text,
  Anchor,
} from 'grommet';

const Welcome = () => (
  <React.Fragment>
    <Heading color="brand" level={2} size="small" margin={{ bottom: 'none' }}>Sua conta foi confirmada!</Heading>
    <br />
    <Text>Caso você não tenha informado um código de cadastro de um assessor de investimentos, você receberá em alguns segundos um e-mail de boas-vindas com tudo que você precisa saber para contratar nosso serviços, planos e também informações sobre apurações passadas (impostos atrasados).</Text>
  </React.Fragment>
);

Welcome.propTypes = {};

export default Welcome;
